<template>
  <article class="pre-registration">
    <header class="pre-registration__header">
      <p class="pre-registration__greeting">
        <strong><big>Seja bem-vindo ao Dr. Conecta.</big><br />
        Por favor, preencha os seus dados para começar a usar a nossa plataforma.</strong>
      </p>
    </header>

    <form @submit.prevent="submit()" v-if="loaded" class="pre-registration__form">
      <dr-field
        prefix="form1"
        class="text-left pre-registration__form-field"
        v-for="(field, name) in formData"
        :form.sync="formData"
        :field.sync="field"
        :validators.sync="$v.formData[name]"
        :apiErrors.sync="apiErrors[name]"
        :id="name"
        :ref="name"
        :key="'main_'+name">
      </dr-field>

      <p
        v-if="$v.$invalid && sending"
        class="pre-registration__warning text-warning col-12 text-center"
      >
        Por favor complete o formulário corretamente
      </p>

      <div class="pre-registration__tos" :class="$v.tos.$invalid && sending ? 'has-error' : ''">
        <label class="form-checkbox">
          <input type="checkbox" v-model="tos">
          <i class="form-icon"></i> <strong>Eu concordo com os <a @click="showTos($event)">termos de uso</a></strong>
        </label>
      </div>

      <div class="pre-registration__footer">
        <dr-submit
          :disabled="$v.$invalid"
          :sending="sending"
          text="Cadastrar agora"
        />
      </div>
    </form>
  </article>
</template>
<script>
import drField from '@/components/form/field'
import drSubmit from '@/components/form/submit'
import {formData, validations} from '@/data/formData/preRegistration'
import { sameAs } from 'vuelidate/lib/validators'
import tos from '@/data/miscData/tos'

export default {
  components: {
    drField,
    drSubmit
  },
  data () {
    return {
      formData: formData,
      tos: false,
      apiErrors: this.fn_BUILD_API_ERRORS(formData),
      loaded: false,
      sending: false
    }
  },
  validations: {
    formData: validations,
    tos: {
      checked: sameAs(function () { return true })
    }
  },
  mounted () {
    this.$http.get('/medical_specialty?itensPerPage=all').then(
      (res) => {
        console.log(res.data.data)
        this.formData.medicalSpecialty.options = res.data.data
        for (let field in this.formData) {
          this.formData[field].value = null
        }
        this.loaded = true
        this.fn_HIDE_PROGRESS()
      }
    )
  },
  methods: {
    showTos (event) {
      event.stopPropagation()
      event.preventDefault()
      this.$store.dispatch('setModalAlert', {
        title: 'Termos de uso',
        body: tos,
        size: 'lg',
        active: true
      })
    },
    submit () {
      this.apiErrors = this.fn_BUILD_API_ERRORS(formData)
      this.sending = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.sending = false
        return
      }
      this.fn_SHOW_PROGRESS()
      let data = this.fn_COPY_OBJECT(this.formData)

      data['user.contactPhone'].value = this.fn_NUMBERS_ONLY(data['user.contactPhone'].value)
      data['user.cpf'].value = this.fn_NUMBERS_ONLY(data['user.cpf'].value)

      data = this.fn_EXPAND_OBJECT(data)
      data['hasTermsOfUse'] = this.tos

      this.$http.post('/doctor/pre_registration', {'pre_registration': data}).then(
        (res) => {
          this.sending = false
          this.$router.push({name: 'RegisterPreRegistrationSuccess'})
        }
      ).catch(
        (err) => {
          this.fn_HIDE_PROGRESS()
          console.log(data)
          if (err.status === 400 || err.code === 400) {
            this.fn_FLATTEN_OBJECT(err.errors.children).then(
              (res) => {
                for (let field in res) {
                  this.apiErrors[field.replace(/.children|.errors/g, '')] = res[field]
                }
                this.sending = false
                this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.form)
              }
            )
          } else {
            console.log(err)
            this.sending = false
            this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.server)
          }
        }
      )
    }
  }
}
</script>
